/** Roll values and the kit-owned draft binding shared by the two roll homes. */
import { useTabDraft } from "@/components/ui/box-draft";
import type { AttendanceStatus } from "@/lib/api/attendance";
const PREFIX = "imam:roll-draft:v1:";
const UNBOUND_PREFIX = "imam-lms-attendance-draft:";
export const ROLL_RECOVERY_CLEARED = "imam:roll-recovery-cleared";

export type RollMark = { status: AttendanceStatus; camera_on: boolean };

export interface RollDraft {
  marks: Record<string, RollMark>;
  /** The starting marks let a restored draft send only the teacher's changes. */
  base_marks?: Record<string, RollMark>;
  /** After Load, old marks remain a re-entry reference until this teacher records the roll. */
  reentry_marks?: Record<string, RollMark>;
  roll_updated_at: string | null;
}

export function useRollDraft(session: string, version: string | null) {
  return useTabDraft<RollDraft | null, { key: string }>({ box: "course-roll", record: session, version, initial: null });
}

/** Remove pre-kit copies and stop open legacy register writers on sign-out. The kit clears current drafts. */
export function clearRollRecovery(): void {
  window.dispatchEvent(new Event(ROLL_RECOVERY_CLEARED));
  try {
    for (let index = localStorage.length - 1; index >= 0; index--) {
      const key = localStorage.key(index);
      if (key?.startsWith(PREFIX) || key?.startsWith(UNBOUND_PREFIX)) localStorage.removeItem(key);
    }
  } catch {
    // A denied store cannot prevent sign-out.
  }
}

/** Disclosure preferences share the browser store, scoped to the same actor. */
export function readRollExpanded(tenant: string, owner: string, session: string): boolean | null {
  try {
    const value = localStorage.getItem(`imam:roll-expanded:${tenant}:${owner}:${session}`);
    return value === "open" ? true : value === "closed" ? false : null;
  } catch { return null; }
}

export function writeRollExpanded(tenant: string, owner: string, session: string, expanded: boolean): void {
  try { localStorage.setItem(`imam:roll-expanded:${tenant}:${owner}:${session}`, expanded ? "open" : "closed"); } catch { /* Preference only. */ }
}
